import { useAlert } from '@orientaction/hooks';
import { RefObject, useEffect, useState } from 'react';
import NeedsProResultPDF from '../../../../../PageResultat/NeedsProResult/ResultatPDF';
import NeedsResultPDF from '../../../../../PageResultat/NeedsResult/ResultatPDF';
import { prepareNeedsPdfResult } from './needsPdfPyramids';

type NeedsResultPdfProps = {
  kind: 'needs' | 'needsPro';
  myResult: any;
  resultId: number;
  pdfRef: RefObject<any>;
};

const NeedsResultPdf = ({ kind, myResult, resultId, pdfRef }: NeedsResultPdfProps) => {
  const alert = useAlert();
  const [prepared, setPrepared] = useState<{ source: any; result: any } | null>(null);

  useEffect(() => {
    let active = true;
    prepareNeedsPdfResult(kind, myResult)
      .then(result => {
        if (active) {
          setPrepared({ source: myResult, result });
        }
      })
      .catch(() => {
        if (active) {
          alert.openSimpleAlert('Impossible de préparer les pyramides du PDF.');
        }
      });
    return () => {
      active = false;
    };
    // The alert helper is recreated on each render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kind, myResult]);

  if (!prepared || prepared.source !== myResult) {
    return null;
  }
  const Pdf = kind === 'needsPro' ? NeedsProResultPDF : NeedsResultPDF;
  return <Pdf ref={pdfRef} myResult={prepared.result} idResult={resultId} />;
};

export default NeedsResultPdf;
